import api from './api.service';

type ApiBody<T> = { success?: boolean; data?: T; message?: string };

async function unwrap<T>(promise: Promise<unknown>): Promise<T> {
  const body = (await promise) as ApiBody<T>;
  if (body?.data === undefined) throw new Error(body?.message || 'Readiness request failed');
  return body.data;
}

export const readinessService = {
  getDashboard: () => unwrap<Record<string, unknown>>(api.get('/readiness/dashboard')),
  getRuntime: () => unwrap<Record<string, unknown>>(api.get('/readiness/runtime')),
  getIndexes: () => unwrap<Record<string, unknown>>(api.get('/readiness/db/indexes')),
  getSlowQueries: () => unwrap<unknown[]>(api.get('/readiness/db/slow-queries')),
  getApiLatency: () => unwrap<Record<string, unknown>>(api.get('/readiness/api/latency')),
  getScale: () => unwrap<Record<string, unknown>>(api.get('/readiness/scale/status')),
  getSecurity: () => unwrap<Record<string, unknown>>(api.get('/readiness/security/events')),
  getHealthGraph: () => unwrap<Record<string, unknown>>(api.get('/readiness/observability/health-graph')),
  getSlos: () => unwrap<unknown[]>(api.get('/readiness/slo')),
  getCompliance: () => unwrap<Record<string, unknown>>(api.get('/readiness/compliance/controls')),
  search: (q: string) =>
    unwrap<Record<string, unknown>>(api.get('/readiness/search', { params: { q } })),
  enqueueReport: (payload: Record<string, unknown>) =>
    unwrap<unknown>(api.post('/readiness/reports/jobs', payload)),
  listReports: () => unwrap<unknown[]>(api.get('/readiness/reports/jobs')),
  getDr: () => unwrap<Record<string, unknown>>(api.get('/readiness/dr/status')),
  getDevops: () => unwrap<Record<string, unknown>>(api.get('/readiness/devops/status')),
  getIntegrations: () => unwrap<Record<string, unknown>>(api.get('/readiness/integrations/catalog')),
  getAiPerf: (hours = 24) =>
    unwrap<Record<string, unknown>>(api.get('/readiness/ai/performance', { params: { hours } })),
  getCustomerSuccess: (refresh = false) =>
    unwrap<Record<string, unknown>>(
      api.get('/readiness/customer-success', { params: refresh ? { refresh: 1 } : {} })
    ),
  getBenchmarking: () => unwrap<Record<string, unknown>>(api.get('/readiness/benchmarking')),
};
